import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * Reads a one-time deep-link id out of `location.state` and clears the state
 * so Back navigation doesn't re-trigger it. Returns the id for the caller to
 * pass as `useListViewSelection`'s `preferredId`, which re-applies it on
 * every default-selection event instead of racing a one-shot consumption.
 */
const useDeepLinkSelection = (stateKey: string) => {
  const history = useHistory();
  const location = useLocation<
    Record<string, string | undefined> | undefined
  >();
  const [deepLinkId, setDeepLinkId] = useState<string | null>(null);

  useEffect(() => {
    const id = location.state?.[stateKey];
    if (id) {
      setDeepLinkId(id);
      history.replace({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        state: undefined
      });
    }
    // Run only on mount — location.state carries the one-time deep-link payload.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return deepLinkId;
};

export default useDeepLinkSelection;
